import React from 'react';
import '../App.css'; // Optional: If you're using an external CSS file
import Button from './Button';


const Table1 = ({ headers, data = [], optview, optselect, optdeselect, optedit, optdelete, onClickView, onClickEdit,onClickDelete, onClickSelect, onClickDeselect }) => {
  const EndButtons = ({ optview, optdeselect, optselect, optedit, optdelete, data, rowIndex }) => (
    <td style={{ display: 'flex', flexDirection: 'row' }}>
      {optedit && <button text="Edit" color="#61BAA5" onClick={() => onClickEdit(data)}>✏️</button>}
      {optdeselect && <Button text="Deselect" color='#8B0000' onClick={() => onClickDeselect()} />}
      {optselect && <Button text="Select" color="#61BAA5" onClick={() => onClickSelect(data)} />}
      {optdelete && <button onClick={() => onClickDelete(data, rowIndex)}>🗑️</button>}
      {optview && <Button text="View" color="#318acc" onClick={() => { onClickView(data) }} />}
    </td>
  );

  return (
    <table className="clients-table">
      <thead className="table-header">
        <tr>
          {headers.map((item, index) => (
            <td key={index}>{item}</td>
          ))}
          {(optview || optdeselect || optedit || optdelete || optselect) && <td></td>}
        </tr>
      </thead>
      <tbody>
  {data && data.length > 0 ? (
    data.map((item, index) => (
      <tr 
        key={index} 
        className={`body-row ${index % 2 !== 0 ? "gray-row" : ""}`}
      >
        {Object.values(item).map((content, index1) => (
          <td key={index1}>
            {React.isValidElement(content) ? content : content} 
          </td>
        ))}
        {(optview || optdeselect || optselect || optedit || optdelete) && (
          <EndButtons 
            data={item}
            rowIndex={index} 
            optselect={optselect} 
            optdeselect={optdeselect}
            optdelete={optdelete} 
            optedit={optedit} 
            optview={optview} 
          />
        )}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={headers.length + 1}>No data found</td>
    </tr>
  )}
</tbody>

    </table>
  );
};

export default Table1;
